module.exports = __webpack_public_path__ + "img/user-x-02.9c1ee150.svg";